/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
// import _ from 'lodash';

import { Action, ActionType } from '../actionTypes/projectPersonalActionTypes';
import { IProjectPersonalReport, IProjectPersonal as ProjectPersonal } from '../../models/projectPersonal';

export interface IProjectPersonalsState {
    projectPersonals: ProjectPersonal[];
    projectPersonalsReport: IProjectPersonalReport[];
    loading: boolean;
    error: string | null,
}
const initialState = {
    projectPersonals: [],
    projectPersonalsReport: [],
    loading: false,
    error: null,   
};
export const ProjectPersonalReducer: Reducer<IProjectPersonalsState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_PROJECTPERSONALS:
        case ActionType.FETCH_PROJECTPERSONALSREPORT:
        case ActionType.ADD_PROJECTPERSONAL:
        case ActionType.EDIT_PROJECTPERSONAL:
        case ActionType.DELETE_PROJECTPERSONAL:
            return { ...state, loading: true };

        case ActionType.FETCH_PROJECTPERSONALS_FAIL:
        case ActionType.FETCH_PROJECTPERSONALSREPORT_FAIL:
        case ActionType.ADD_PROJECTPERSONAL_FAIL:
        case ActionType.EDIT_PROJECTPERSONAL_FAIL:
        case ActionType.DELETE_PROJECTPERSONAL_FAIL:
            return { 
                ...state, 
                loading: false,
                error: action.payload
            };

        case ActionType.ADD_PROJECTPERSONAL_SUCCESS:
            // console.log("action.payload: ", action.payload)
            return {
                ...state,
                projectPersonals: [ ...state.projectPersonals, action.payload ],
                loading: false
            };

        case ActionType.FETCH_PROJECTPERSONALS_SUCCESS:
            return {
                ...state,
                projectPersonals: action.payload.data,
                loading: false
            };

        case ActionType.FETCH_PROJECTPERSONALSREPORT_SUCCESS:
            return {
                ...state,
                projectPersonalsReport: action.payload.data,
                loading: false
            };
                
        case ActionType.EDIT_PROJECTPERSONAL_SUCCESS:
            const projectPersonal: ProjectPersonal = action.payload
            const index = state.projectPersonals.findIndex(itm => 
                Number(itm.projectpersonelid) === Number(projectPersonal.projectpersonelid)
            )
            const projectPersonalsPart1 = state.projectPersonals.slice(0, index)
            const projectPersonalsPart2 = state.projectPersonals.slice(index + 1)
            return {
                ...state,
                projectPersonals: [ ...projectPersonalsPart1, projectPersonal, ...projectPersonalsPart2 ],
                loading: false
            };
        case ActionType.DELETE_PROJECTPERSONAL_SUCCESS:
            return {
                ...state,
                projectPersonals: state.projectPersonals.filter(projectPersonal => projectPersonal.projectpersonelid !== action.payload),
            };

        default:

            return state;
    }
};
